// extracted by mini-css-extract-plugin
export default {"searchResults":"bq_ks","resultsMessage":"bq_kt","breadcrumb":"bq_kv","isOpen":"bq_h5","hitCount":"bq_kw","hasResults":"bq_kx"};